import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, consigneeValidations } from "./consignee-schema";
import { createConsignee } from "services/data.internal.service";
import ConsigneeInfo from "./components/ConsigneeInfo";
import { useCustomerValue } from "providers/CustomerContext";

function AddConsignee() {
  const { customerCode: custCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const createConsigneeMutation = useMutation(createConsignee, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: { ...initialValues, customerCode: custCode },
    values: { ...initialValues, customerCode: custCode },
    resolver: yupResolver(consigneeValidations),
  });

  const {
    register,
    getValues,
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    register,
    getValues,
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    window.scrollTo(0, 0);
    createConsigneeMutation.mutate(data, {
      onSuccess: () => reset(),
    });
  };
  return (
    <Layout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <ConsigneeInfo {...infoProps} />
        <SubmitButton label="submit" disabled={isSubmitting} url="/setup/consignee" />
      </form>
    </Layout>
  );
}

export default AddConsignee;
